"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStorageValueProvider = buildStorageValueProvider;
const StorageClient_1 = require("@juvare/platform-sdk-js/StorageClient");
function buildStorageValueProvider({ baseUrl, tokenProvider, entityName, classifierName, displayOrder, label, getValues, }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const client = new StorageClient_1.StorageClient(entityName, baseUrl, tokenProvider);
    return {
        type: 'classifier.' + (classifierName ?? entityName),
        label: label,
        getValues: getValues
            ? (params) => getValues(client, params)
            : () => client
                .list({
                filter: [{ column: 'status', op: '=', value: 'active' }],
                orderBy: displayOrder ? [{ column: 'displayOrder' }, { column: 'name' }] : [{ column: 'name' }],
            })
                .then((result) => result.rows.map((row) => ({ value: row.id, label: row.columns.name }))),
    };
}
